import React from 'react';
import { FiImage, FiTrash2 } from 'react-icons/fi';
import { HeaderCell } from './ListTableColumn';

export const getListDetailsTableColumns = (handleSort, sortDirection = {}, handleRemoveProduct) => [
	{
		field: 'PRODUCTNAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 220,
		flex: 1.5,
		headerComponent: () => (
			<HeaderCell field="PRODUCTNAME" label="PRODUCTNAME" handleSort={handleSort} sortDirection={sortDirection} />
		),
		cellRenderer: (params) => (
			<div className="d-flex align-items-center gap-2" data-testid={`product-list-detail-row-${params.data?.id}`}>
				<div className="list-thumb-icon d-flex align-items-center justify-content-center rounded ms-1">
					<FiImage />
				</div>
				<span className="fw-semibold text-dark">{params.value}</span>
			</div>
		),
	},
	{
		field: 'UPC',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1.2,
		headerComponent: () => <HeaderCell field="UPC" label="UPC" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="text-secondary">{params.value || '-'}</span>,
	},
	{
		field: 'CATEGORY',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => <HeaderCell field="CATEGORY" label="CATEGORY" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="text-secondary">{params.value || '-'}</span>,
	},
	{
		field: 'AVAILABLE STOCK',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 160,
		flex: 1,
		headerComponent: () => <HeaderCell field="AVAILABLE STOCK" label="AVAILABLE STOCK" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="fw-semibold text-success">{params.value}</span>,
	},
	{
		field: 'UNIT PRICE',
		headerClass: 'HeaderBg right-align',
		cellClass: 'right-align',
		suppressSizeToFit: true,
		minWidth: 130,
		flex: 1,
		headerComponent: () => <HeaderCell field="UNIT PRICE" label="UNIT PRICE" handleSort={handleSort} sortDirection={sortDirection} isRight={true} />,
		cellRenderer: (params) => <span className="fw-semibold text-dark">{params.value}</span>,
	},
	{
		field: 'ACTIONS',
		headerName: 'ACTIONS',
		headerClass: 'HeaderBg text-center',
		cellClass: 'text-center',
		suppressSizeToFit: true,
		minWidth: 100,
		flex: 0.8,
		sortable: false,
		cellRenderer: (params) => (
			<button
				type="button"
				className="btn p-1 text-danger border-0 bg-transparent"
				title="Remove Product from List"
				data-testid={`product-list-detail-remove-product-btn-${params.data?.id}`}
				onClick={() => handleRemoveProduct && handleRemoveProduct(params.data?.id)}
			>
				<FiTrash2 className="action-trash-icon" />
			</button>
		),
	},
];
